import { createApp } from 'vue'
import App from './App.vue'
import router from './utils/router'
import axios from './utils/axios'

import { Button, NavBar, Field, CellGroup, NoticeBar, Collapse, CollapseItem, Cell, Icon, PullRefresh, Empty, Dialog, SwipeCell,ActionSheet } from 'vant';

const app = createApp(App);

app.use(Button);
app.use(NavBar);
app.use(Field);
app.use(Cell);
app.use(CellGroup);
app.use(NoticeBar);
app.use(Collapse);
app.use(CollapseItem);
app.use(Icon);
app.use(PullRefresh);
app.use(Empty); 
app.use(Dialog); 
app.use(SwipeCell); 
app.use(ActionSheet);
 
app.use(router);
app.config.globalProperties.$axios = axios;
app.mount('#app');
